export enum LoaderSpinnerSize {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}

export enum LoaderSpinnerColor {
  blue = 'blue',
  white = 'white'
}
